import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { error } from 'react-notification-system-redux';
import { useDashboardAPI } from '../../../hooks';
import { notificationsConfig } from '../../../config/constants';
import { useFarmId } from './useFarmId';
export const useInventoryQuery = (options) => {
    const farmId = useFarmId(options);
    const dispatch = useDispatch();
    const api = useDashboardAPI();
    return useQuery({
        refetchOnMount: true,
        refetchOnReconnect: true,
        refetchOnWindowFocus: true,
        onError: () => {
            dispatch(error({
                translationKey: 'widget:widget:cant_load_inventory',
                ...notificationsConfig.defaultConf,
            }));
        },
        ...options,
        enabled: !!farmId,
        queryFn: () => api.inventory.getInventory(farmId),
        queryKey: ['inventory'],
        select: (data) => (Array.isArray(data) ? data : []),
    });
};
//# sourceMappingURL=useInventoryQuery.js.map